import React from "react";
import { Header } from "../components/common/Header";
import Footer from "../components/common/Footer";
import backgroundImage from "../assets/img/Om.png";

// Import your new CSS file
import "./About.css";

export const About = () => {
  return (
    <div className="about-container">
      <Header active={2} />

      <main className="about-hero">
        {/* Dark overlay */}
        <span className="about-overlay"></span>

        {/* Hero text */}
        <div className="about-hero-content">
          <h1 className="about-hero-title">Om oss</h1>
          <p className="about-hero-subtitle">
            {/* Short text or highlight for the hero section */}
          </p>
        </div>
      </main>

      {/* Main body text under the hero */}
      <div className="about-body">
        <p className="about-body-text">
          Kifo Bokförlag grundades i oktober 2023.
          <br />
          Kifo Bokförlag har som mål att tillgängliggöra kristna barnböcker och
          översätta syriska kyrkofäders verk till svenska. Syftet med dessa böcker är
          att utbilda barn och vuxna i den kristna tron i allmänhet och i den
          Syrisk-ortodoxa kyrkans arv i synnerhet.
          <br />
          Grunden till kyrkans tro är bekännelsen som Simon gjorde om Jesus: "Du är
          Messias, den levande Gudens Son." (Matt 16:16) Då svarade Jesus: "Salig är
          du, Simon, Jonas son, för det är inte kött och blod som har uppenbarat det
          för dig, utan min Far i himlen. Och jag säger dig: Du är Petrus, och på
          denna klippa ska jag bygga min församling, och helvetets portar ska inte få
          makt över den." (Matt 16:17-18)
          <br />
          Av denna anledning valde vi att namnge vårt bokförlag för Kifo eftersom det är
          det syriska ordet för Petrus som på grekiska betyder klippa. Vi hoppas att
          Kifo Bokförlag kan vara en trons klippa för många som tar del av de böcker
          som publiceras av Kifo Bokförlag.
          <br />
          Isabell Üre Kaya & Sebastian Kaya
        </p>
      </div>

      <Footer />
    </div>
  );
};
